// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChatBox_wrapper__zXvtX"};